import React from 'react';
import {
    Box,
    Container,
    Grid,
    Typography,
    Link,
    Divider,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from '@mui/material';
import {
    Facebook as FacebookIcon,
    Twitter as TwitterIcon,
    Instagram as InstagramIcon,
    LinkedIn as LinkedInIcon,
    Email as EmailIcon
} from '@mui/icons-material';

const AppFooter = () => {
    return (
        <Box
            component="footer"
            sx={{
                py: 5,
                backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[200]
                        : theme.palette.grey[800],
                mt: 'auto'
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* Group Services */}
                    <Grid item xs={6} md={2}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                            Group Services
                        </Typography>
                        <Link href="/tutorials/group-creation" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover" display="block" mb={1}>
                            Group Creation Tutorial
                        </Link>
                        <Link href="/tutorials/manage-members" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover" display="block" mb={1}>
                            Member Management
                        </Link>
                        <Link href="/tutorials/group-management" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover" display="block" mb={1}>
                            Group Management
                        </Link>
                        <Link href="/tutorials/renew-group" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover" display="block" mb={1}>
                            Renew Group
                        </Link>
                    </Grid>

                    {/* Group Services */}
                    <Grid item xs={6} md={2}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                            Event Management
                        </Typography>
                        <Link href="/tutorials/event-creation" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover" display="block" mb={1}>
                            Event Creation Tutorial
                        </Link>
                        <Link href="/tutorials/manage-tickets" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover" display="block" mb={1}>
                            Ticket Management
                        </Link>
                    </Grid>



                    {/* Resources */}
                    <Grid item xs={6} md={2}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                            Resources
                        </Typography>
                        <Link href="/resources/articles"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            Articles
                        </Link>
                        <Link href="/resources/debt-management"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            Debt Management Tools
                        </Link>
                        <Link href="/resources/credit-tools"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            Credit Tools
                        </Link>
                        <Link href="/resources/budget-tools"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            Budget Tools
                        </Link>
                        <Link href="/resources/retirement-calculator"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            Retirement Calculator
                        </Link>
                        <Link href="/resources/mortgage-calculator"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            Mortgage Calculator
                        </Link>
                        <Link href="/faq"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            FAQs
                        </Link>
                    </Grid>

                    {/* Company */}
                    <Grid item xs={6} md={2}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                            Company
                        </Typography>
                        <Link href="/about-us"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            About us
                        </Link>
                        <Link href="/careers"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            Careers
                        </Link>
                        <Link href="/pricing" color="inherit" underline="hover" display="block" mb={1}>
                            Pricing & Fees
                        </Link>
                        <Link href="/contact-us"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            Contact Us
                        </Link>
                    </Grid>

                    {/* Legal */}
                    <Grid item xs={6} md={2}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                            Legal and Regulatory
                        </Typography>
                        <Link href="/legal/documents/terms-and-conditions"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            Terms & Conditions
                        </Link>
                        <Link href="/legal/documents/privacy" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover" display="block" mb={1}>
                            Privacy
                        </Link>
                        <Link href="/legal/documents/disclosure"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            Disclosure
                        </Link>
                        <Link href="/legal/documents/cookie"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            Cookie Policy
                        </Link>
                        <Link href="/legal/documents/aml-ctf"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            AML/CTF Policy
                        </Link>
                        <Link href="/legal/documents/security"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            Security Policy
                        </Link>
                        <Link href="/legal/documents/acceptable-use-policy"  target="_blank" rel="noopener noreferrer"  color="inherit" underline="hover" display="block" mb={1}>
                            Acceptable Use Policy
                        </Link>
                    </Grid>

                    {/* Contact Info */}
                    <Grid item xs={12} md={4}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                            Contact Us
                        </Typography>
                            <List dense disablePadding sx={{ mt: -0.5, py: 0 }}>
                                <ListItem disableGutters sx={{ py: 0 }}>
                                    <ListItemButton component="a" href="https://facebook.com/uniofunds" target="_blank" rel="noopener noreferrer" sx={{ py: 0.25, minHeight: 30, px: 0 }}>
                                        <ListItemIcon sx={{ minWidth: 0, mr: 1, color: 'text.secondary' }}>
                                            <FacebookIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText primary="Facebook" primaryTypographyProps={{ variant: 'body2' }} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disableGutters sx={{ py: 0 }}>
                                    <ListItemButton component="a" href="https://twitter.com/uniofunds" target="_blank" rel="noopener noreferrer" sx={{ py: 0.25, minHeight: 30, px: 0 }}>
                                        <ListItemIcon sx={{ minWidth: 0, mr: 1, color: 'text.secondary' }}>
                                            <TwitterIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText primary="Twitter" primaryTypographyProps={{ variant: 'body2' }} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disableGutters sx={{ py: 0 }}>
                                    <ListItemButton component="a" href="https://instagram.com/uniofunds" target="_blank" rel="noopener noreferrer" sx={{ py: 0.25, minHeight: 30, px: 0 }}>
                                        <ListItemIcon sx={{ minWidth: 0, mr: 1, color: 'text.secondary' }}>
                                            <InstagramIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText primary="Instagram" primaryTypographyProps={{ variant: 'body2' }} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disableGutters sx={{ py: 0 }}>
                                    <ListItemButton component="a" href="https://www.linkedin.com/in/uniofunds-admin-89a050391" target="_blank" rel="noopener noreferrer" sx={{ py: 0.25, minHeight: 30, px: 0 }}>
                                        <ListItemIcon sx={{ minWidth: 0, mr: 1, color: 'text.secondary' }}>
                                            <LinkedInIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText primary="LinkedIn" primaryTypographyProps={{ variant: 'body2' }} />
                                    </ListItemButton>
                                </ListItem>
                            </List>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />

                <Typography variant="body2" color="text.secondary" align="center">
                    © {new Date().getFullYear()} UnioFunds. All rights reserved.
                </Typography>
            </Container>
        </Box>
    );
};

export default AppFooter;